import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { maintenanceRoutes } from "./maintenanceRoutes";

const router = createBrowserRouter(maintenanceRoutes);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
